export const ResourcesPage = () => {
    return (
        <div>
            <h1>Resources</h1>
        </div>
    )
}